import React from 'react';
import TabularDataCell from './TabularDataCell.js';

export default function TabularDataRows(props) {
	let activeProdLookUp = {};
	props.compareItems.forEach((prod) => {
		activeProdLookUp[prod.id] = prod.isSelected;
	});
	if (props.row) {
		let rowData = props.row;
		let TableDataCells = rowData.value.map((cell, indx) => {
			if (activeProdLookUp[cell.id]) {
				return <TabularDataCell key={indx} cellData={cell} />;
			} else {
				return null;
			}
		});

		return (
			<div className="comparison-feature__content">
				<div className="comparison-feature__content-featurename">
					<p className="trailer-0 padding-trailer-0">{rowData.key}</p>
				</div>
				<div className="comparison-feature__content-rows">{TableDataCells}</div>
			</div>
		);
	} else {
		console.error('%c There is a problem with the Row data, please check source! ', 'background: orange; color: black');
		return null;
	}
}
